import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-zerosix-account-not-found-step',
  templateUrl: './zerosix-account-not-found-step.component.html',
  standalone: false,
})
export class ZerosixAccountNotFoundStepComponent {
  @Output() goToPhoneStep = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<Event>();

  onGoToPhoneStep(): void {
    this.goToPhoneStep.next();
  }
}
